import(/* webpackMode: "eager" */ "/app/src/ui/views/auth/recovery/ForgotPasswordView/ForgotPasswordView.tsx");
